import Vue from "vue";
import Router from "vue-router";
import store from "../store"; // <-- aliased path

import { getFlatRoutes, flatRoutes } from "../common/constants/routes";

import Login from "@/pages/login";
import NotFound from "@/pages/not-found";
import DomainPageTemplate from "@/pages/temps/pages/DomainPageTemplate";
import RegisterPageTemplate from "@/pages/temps/pages/RegisterPageTemplate";
import Alerts from "@/pages/alertPage/View.vue";

// import Weather from "@/pages/monitoringPages/weather";
import Monitoring from "@/pages/monitoring";
import Ferti from "@/pages/monitoringPages/ferti";
import Station from "@/pages/monitoringPages/Station/View.vue";
import MonitDirs from "@/pages/monitoringPages/Dirs/View.vue";
import MonitEqps from "@/pages/monitoringPages/Actuators/View.vue";
import MonitScdl from "@/pages/monitoringPages/Schedules/View.vue";
import MonitSnrs from "@/pages/monitoringPages/Sensors/View.vue";
import Charts from "@/pages/monitoringPages/Charts/View.vue";
import ManualStation from "@/pages/registerPages/Management/ManualStation.vue";
import RegisterSoil from "@/pages/registerPages/Management/Soil.vue";
import Reports from "@/pages/monitoringPages/Reports/View.vue";
import SectorMonitoring from "@/pages/monitoringPages/Sectors/View.vue";
import FarmsMonitoring from "@/pages/monitoringPages/Farms/View.vue";
import PlatformNews from "@/pages/platformNews/View.vue";

import Sectors from "@/pages/registerPages/Sectors/View.vue";
import Equipments from "@/pages/registerPages/Equipments/View.vue";
import Schedule from "@/pages/registerPages/Schedules/View.vue";
import Route from "@/pages/registerPages/Routes/View.vue";
import Devices from "@/pages/registerPages/Dirs/View.vue";
import User from "@/pages/registerPages/Users/View.vue";
import Management from "@/pages/registerPages/Management/View.vue";
import ManagementConfigs from "@/pages/registerPages/Management/components/ManagementConfigs.vue";
import Network from "@/pages/configPages/NetworkView.vue";
import Logs from "@/pages/configPages/LogsView.vue";
import Map3v3 from "@/pages/configPages/MapView.vue";
import General from "@/pages/configPages/GeneralView.vue";
import Resets from "@/pages/configPages/ResetView.vue";
import Advanced from "@/pages/configPages/AdvancedView.vue";

const formattedRoutes = flatRoutes.map((route) => {
  const routeFormatted = {
    path: route.fullPath,
    name: route.routeName,
    componentName: route.componentName,
    redirect: route.redirect,
    props: route.props,
  };

  if (!routeFormatted.redirect) {
    delete routeFormatted.redirect;
  }

  if (!routeFormatted.componentName) {
    delete routeFormatted.componentName;
  }

  if (!routeFormatted.name) {
    delete routeFormatted.name;
  }

  if (!routeFormatted.props) {
    delete routeFormatted.props;
  }

  if (!routeFormatted.path) {
    delete routeFormatted.path;
  }

  return routeFormatted;
});

const componentsList = {
  Monitoring,
  Ferti,
  Station,
  MonitDirs,
  MonitEqps,
  MonitScdl,
  MonitSnrs,
  Charts,
  Reports,
  SectorMonitoring,
  FarmsMonitoring,
  DomainPageTemplate,
  ManualStation,
  Schedule,
  Equipments,
  Sectors,
  RegisterSoil,
  Equipments,
  Schedule,
  Route,
  Devices,
  User,
  Management,
  Alerts,
  RegisterPageTemplate,
};

const servedRoutes = formattedRoutes.map((route) => {
  route.component = route.componentName
    ? componentsList[route.componentName]
    : undefined;
  return route;
});

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  scrollBehavior(to, from, savePosition) {
    document.body.scrollTop = 0;
    return null;
  },
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: Login },
    { path: "/news", component: PlatformNews },
    { path: "/404", component: NotFound },
    ...servedRoutes,
    { path: "/config/network", name: "network", component: Network },
    { path: "/config/logs", name: "logs", component: Logs },
    { path: "/config/map", name: "map", component: Map3v3 },
    { path: "/config/general", name: "general", component: General },
    { path: "/config/reset", name: "reset", component: Resets },
    { path: "/config/advanced", name: "advanced", component: Advanced },
    {
      path: "/config/management",
      name: "management-configs",
      component: ManagementConfigs,
    },
    { path: "/registers/devices/:type?", name: "devices", component: Devices },
  ],
});

export default router;
